export const LIVE_BYTES_ADDED_EVENT = 'live-bytes-added-event'
export const LIVE_BYTES_DELETED_EVENT = 'live-bytes-deleted-event'
export const LIVE_BYTES_EDITED_EVENT = 'live-bytes-edited-event'
export const LIVE_BYTES_RECONNECT_EVENT = 'live-bytes-reconnect-event'

export const LIVE_BYTES_ORIGIN = {
  DATALAB: 'DataLab',
  TELEGRAM: 'Telegram'
}
